module.exports = __webpack_public_path__ + "img/cambodia.83e1888.webp";